import * as React from "react";
import type { SVGProps } from "react";
const SvgAltArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#FFB70F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15 5-6 7 6 7"
    />
  </svg>
);
export default SvgAltArrowLeft;
